export default __webpack_public_path__ + "static/media/sign_b.b427bf77.png";